import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import './PersonalData.css';
import Info from '../Info/Info.js';
import { PencilIcon } from '../../../../common/icons';
import { Popover } from 'antd';
import AirButton from '../../../../common/components/AirButton';
import PropTypes from 'prop-types';

@inject('commonStore', 'translationsStore', 'authStore')
@observer
export default class PersonalData extends Component {
  constructor(props) {
    super(props);
    this.UpdatePersonalDataRef = React.createRef();
    this.state = { visible: false };
  }
  showUpdate = () => {
    this.setState({
      visible: !this.state.visible
    });
  };

  static contextTypes = {
    router: PropTypes.object
  };

  redirect = () => {
    this.context.router.history.push(`/support`);
  };

  render() {
    const { commonStore, translationsStore, authStore } = this.props;

    let profileData = commonStore.dealer;

    if (authStore.isServiceManager) {
      profileData = commonStore.profile;
    }
    return (
      <div className="PersonalData">
        <div className="field">
          <div className="title">{translationsStore.translate('profile.personalData.title')}</div>
          <Popover
            overlayClassName="PersonalDataPopover"
            title={translationsStore.translate('profile.personalData.updateData.text')}
            trigger="click"
            content={<AirButton size="large" light label={translationsStore.translate('profile.personalData.updateData.label')} onClick={this.redirect} />}
          >
            <div className="change">
              <PencilIcon className="pencilIcon" />
              {translationsStore.translate('profile.personalData.change')}
            </div>
          </Popover>
        </div>

        <div className="fields">
          <Info label={translationsStore.translate('profile.personalData.company')} value={!!profileData && profileData.companyName} />
          <div className="divider" />
          <Info label={translationsStore.translate('profile.personalData.email')} value={!!profileData && profileData.email} />
          <div className="divider" />
          <Info label={translationsStore.translate('profile.personalData.phoneNumber')} value={!!profileData && profileData.mobile} />
          <div className="divider" />
          <Info label={translationsStore.translate('profile.personalData.pec')} value="--" />
          <div className="divider" />
          <Info label={translationsStore.translate('profile.personalData.piva')} value="--" />
          <div className="divider" />
          <Info label={translationsStore.translate('profile.personalData.address')} value="--" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Profile/PersonalData/PersonalData.js